var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    "data-imageid": "new-message-outline",
    imageName: "New Message",
    className: "illustrations_image",
    style: {
      width: 193
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_04_new_message_outline",
    "data-name": "#04_new_message_outline"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.23,
    y: 58.73,
    width: 119.47,
    height: 185.23,
    rx: 9.69,
    fill: "#ffffff",
    className: "target-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,245H150.92a10.7,10.7,0,0,1-10.69-10.69V68.42a10.7,10.7,0,0,1,10.69-10.69H251a10.7,10.7,0,0,1,10.7,10.69V234.26A10.7,10.7,0,0,1,251,245ZM150.92,59.73a8.7,8.7,0,0,0-8.69,8.69V234.26a8.7,8.7,0,0,0,8.69,8.69H251a8.7,8.7,0,0,0,8.7-8.69V68.42a8.7,8.7,0,0,0-8.7-8.69Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.91,
    y: 77.43,
    width: 108.11,
    height: 144.86,
    rx: 5.07,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,223.28H152a6.07,6.07,0,0,1-6.07-6.06V82.5A6.07,6.07,0,0,1,152,76.43h98A6.08,6.08,0,0,1,256,82.5V217.22A6.08,6.08,0,0,1,250,223.28ZM152,78.43a4.07,4.07,0,0,0-4.07,4.07V217.22a4.07,4.07,0,0,0,4.07,4.06h98a4.07,4.07,0,0,0,4.07-4.06V82.5A4.07,4.07,0,0,0,250,78.43Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 185.55,
    cy: 69.04,
    r: 1.56,
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.94,70H193a1,1,0,0,1,0-2h24.94a1,1,0,0,1,0,2Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.96,
    cy: 232.53,
    r: 6.57,
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.79 185.68 238.14 185.68 238.14 138.12 200.96 114.03 163.79 138.12 163.79 185.68",
    fill: "#ffbc0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.14,186.68H163.79a1,1,0,0,1-1-1V138.12a1,1,0,0,1,.46-.84l37.17-24.09a1,1,0,0,1,1.09,0l37.17,24.09a1,1,0,0,1,.46.84v47.56A1,1,0,0,1,238.14,186.68Zm-73.35-2h72.35v-46L201,115.22l-36.17,23.45Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.33,
    y: 126.42,
    width: 63.27,
    height: 56.14,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.6,183.56H169.33a1,1,0,0,1-1-1V126.42a1,1,0,0,1,1-1H232.6a1,1,0,0,1,1,1v56.14A1,1,0,0,1,232.6,183.56Zm-62.27-2H231.6V127.42H170.33Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.12,138.18H178.81a1,1,0,0,1,0-2h44.31a1,1,0,0,1,0,2Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.12,146.07H178.81a1,1,0,0,1,0-2h44.31a1,1,0,0,1,0,2Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.12,154H178.81a1,1,0,0,1,0-2h44.31a1,1,0,0,1,0,2Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.12,161.84H178.81a1,1,0,0,1,0-2h44.31a1,1,0,0,1,0,2Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.14 185.68 163.79 185.68 163.79 138.12 238.14 185.68",
    fill: "#ffbc0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.14,186.68H163.79a1,1,0,0,1-1-1V138.12a1,1,0,0,1,1.54-.84l74.35,47.56a1,1,0,0,1-.54,1.84Zm-73.35-2h69.93L164.79,140Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.79 185.68 238.14 185.68 238.14 138.12 163.79 185.68",
    fill: "#ffbc0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.14,186.68H163.79a1,1,0,0,1-.54-1.84l74.35-47.56a1,1,0,0,1,1.54.84v47.56A1,1,0,0,1,238.14,186.68Zm-70.93-2h69.93V140Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.14,186.68a1,1,0,0,1-.54-.15l-37.18-23.78a1,1,0,0,1,1.08-1.69l37.18,23.78a1,1,0,0,1,.3,1.38A1,1,0,0,1,238.14,186.68Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.66,56.05a23.06,23.06,0,0,0-15.41,40.23v12.14l6.85-7.88a23.07,23.07,0,1,0,8.56-44.49Z",
    fill: "#f56132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.25,109.42a.87.87,0,0,1-.35-.07,1,1,0,0,1-.65-.93V96.72a24.13,24.13,0,1,1,8.15,5L237,109.07A1,1,0,0,1,236.25,109.42Zm15.41-52.37a22.07,22.07,0,0,0-14.74,38.49,1,1,0,0,1,.33.74v9.46l5.1-5.86a1,1,0,0,1,1.12-.27,22.07,22.07,0,1,0,8.19-42.56Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.66,75l-3.15,2.77-1.88-2.17,5.12-4.32h3.1V87h-3.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.47,112.23a1,1,0,0,1-1-.91l-.85-9.76a1,1,0,0,1,.91-1.08,1,1,0,0,1,1.08.91l.85,9.76a1,1,0,0,1-.91,1.08Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.46,115a1,1,0,0,1-.85-.47L166,104a1,1,0,0,1,.33-1.38,1,1,0,0,1,1.37.33l6.57,10.58a1,1,0,0,1-.32,1.38A1,1,0,0,1,173.46,115Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35,121.1a1,1,0,0,1-.51-.14l-7.91-4.74a1,1,0,0,1,1-1.72l7.91,4.74a1,1,0,0,1-.52,1.86Z",
    fill: "#dfeaef"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailbox);
export default __webpack_public_path__ + "static/media/emailbox.5ab44b72dba420e472b554644bea77b5.svg";
export { ForwardRef as ReactComponent };